<template>
  <button @click="handleClick" :disabled="disabled" class="btn btn-block" :class="buttonClass">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: Array,
      default: ['bg-mcd-primary']
    },
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.btn {
  font-weight: bold;
}

</style>